export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      userUuid: '1b2c6a69f00ab0ea7583ce9b3c58b4a5',
      name: '管理者 太郎',
      email: 'aaa@aaa.com',
      roleKbn: 1,
      service: {
        serviceUuid: 'services001',
        serviceName: 'アイラ地域サポート'
      },
      linkedCmss: [
        {
          linkCMSMstId: 2,
          linkCMSName: 'バス予約管理CMS',
          linkCMSURL: 'https://xxx.xxx.xxx'
        },
        {
          linkCMSMstId: 1,
          linkCMSName: 'レストラン予約CMS',
          linkCMSURL: 'https://xxx.xxx.xxx'
        }
      ],
      lastLoginAt: 1594880785395,
    }
  }
}